import {
  GET_CITY_LIST_LOADING,
  GET_CITY_LIST_SUCCESS,
  GET_CITY_LIST_FAILED,
  SET_CITY_LIST,
  STATUS_DEFAULT,
  STATUS_GETTING,
  STATUS_GET_SUCCESS,
  STATUS_GET_FAILED,
} from 'Redux/actions/types';

const initialState = {
  status: STATUS_DEFAULT,
  statusCode: null,
  errorCode: null,
  data: null,
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case GET_CITY_LIST_LOADING:
      return {
        status: STATUS_GETTING,
        errorCode: null,
      };

    case GET_CITY_LIST_SUCCESS:
      return {
        data: payload,
        status: STATUS_GET_SUCCESS,
        errorCode: null,
      };

    case GET_CITY_LIST_FAILED:
      return {
        status: STATUS_GET_FAILED,
        statusCode: payload.statusCode,
        errorCode: payload.errorCode,
      };

    case SET_CITY_LIST:
      return {
        ...state,
        status: STATUS_GET_SUCCESS,
        data: payload,
      };

    default:
      return state;
  }
};
